import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { environment } from '@env';
import { Storage } from '@tvd/utils/storage';
import { filter, first, of, switchMap, tap } from 'rxjs';
import { map } from 'rxjs';
import { AuthUser } from './auth-user';

export const adminGuard = () => {
  const user = inject(AuthUser);
  const user$ = toObservable(user.data);
  const http = inject(HttpClient);
  const router = inject(Router);
  const storage = inject(Storage);

  // Check if admin token is already stored
  const storedToken = storage.get('ADMIN_TOKEN');
  if (storedToken) {
    return of(true);
  }

  if (environment.envName !== 'production') {
    return of(true);
  }
  return user$.pipe(
    first((user) => !!user),
    map((user) => {
      const roles = user?.roles || [];
      const role = roles.find((role) => role.role === 'owner');
      if (!role) {
        return router.createUrlTree(['/error/404']);
      }
      const password = prompt('Enter admin password:');
      if (!password) {
        return router.createUrlTree(['/error/404']);
      }

      return { password, orgId: role.organisation };
    }),
    filter((payload) => 'password' in payload),
    switchMap(({ password, orgId }) => {
      return http
        .post<boolean>(`${environment.apiUrl}/admin/${orgId}`, {
          password,
        })
        .pipe(
          tap((isValid) => {
            if (isValid) {
              // Store the admin token for use in chat
              storage.set('ADMIN_TOKEN', password);
            }
          }),
          map((res) => res),
        );
    }),
  );
};
